import React, { ComponentType } from 'react';
import { FloatingTree, useFloatingParentNodeId } from '@floating-ui/react';

export const FloatingTreeContext = <T,>(Component: ComponentType<T>): ComponentType<T> => {
  return (props: T) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const parentId = useFloatingParentNodeId();
    if (parentId === null) {
      return (
        <FloatingTree>
          {/* @ts-expect-error: TS2322*/}
          <Component {...props} />
        </FloatingTree>
      );
    }
    // @ts-expect-error: TS2322
    return <Component {...props} />;
  };
};
